<template>
  <div class="taglist" @mousewheel.prevent="">
    <el-scrollbar style="height:34px;white-space:nowrap" ref="elscrollbar">
      <el-tag :closable="item.name!=tagList[0].name" size="medium" v-for="item in tagList" :key="item.path" @contextmenu.prevent.native="openMenu($event,item,item,path)" @click="tagsJump(item)" @close="closeOneself(item)" :effect="$route.name===item.name||`${$route.name}-${$route.query.id}`==item.name?'dark':'plain'">
        {{item.title}}
      </el-tag>
    </el-scrollbar>
    <ul class="tagmenu" id="menu" v-show="menu">
      <!-- <li @click.stop="refreshTag">刷新</li> -->
      <!-- <li @click.stop="closeTag">关闭</li> -->
      <li @click.stop="closeOther">关闭其他</li>
      <li @click.stop="closeAll">关闭所有</li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      menu: false,//右键菜单
      tagSingle: {},//右键当前数据
      tagIndex: '',//右键当前下标
      tagActive: 0,//选中tag下标
      pitchOn:'',//选中
    }
  },
  created() {
    this.$route.query.id?
    this.pitchOn=this.$route.name+ '-' + this.$route.query.id:this.pitchOn=this.$route.name
  },
  computed: {
    ...mapState({
      isCollapse: state => state.isCollapse,
      tagList: state => state.tagList
    })
  },
  mounted() {
    this.scrollInit()
  },
  methods: {
    //   tag标签右键
    openMenu(e, tag, path) {
      this.tagSingle = tag
      this.tagIndex = path
      this.menu = false
      this.menu = true
      let menuDom = document.querySelector('#menu')
      document.addEventListener('click', this.foo)
      menuDom.style.display = "block";
      this.isCollapse ? menuDom.style.left = e.clientX - 40 + 'px' : menuDom.style.left = e.clientX - 200 + 'px'
      menuDom.style.top = e.clientY - 55 + 'px'
    },
    // 关闭右键菜单
    foo() {
      this.menu = false
    },
    // 标签页滚动效果
    scrollInit() {
      const scrollDiv = this.$refs['elscrollbar'].$refs.wrap;
      // 添加滚轮滚动监听事件
      scrollDiv.addEventListener('mousewheel', handler, false)
      function handler(Event) {
        // 获取滚动方向
        let detail = Event.wheelDelta || Event.detail
        // 定义滚动方向
        const moveForwardStep = 1
        const moveBackStep = 1
        // 定义滚动距离
        let step = 0
        // 判断滚动方向，这里的50可以改，代表滚动幅度
        if (detail < 0) {
          step = moveForwardStep * 50
        } else {
          step = -moveBackStep * 50
        }
        // 对需要滚动的元素进行滚动操作
        scrollDiv.scrollLeft += step
      }
    },
    // 标签跳转
    tagsJump(tag) {
      this.$route.fullPath != tag.path ? this.$router.push(tag.path) : ''
    },
    // 关闭自己
    closeOneself(item) {
      let bool = false
      for (let i in this.tagList) {
        this.tagList[i].path == this.$route.fullPath ? bool = true : bool = false
        if (this.tagList[i] == item) {
          this.$store.commit('DEL_KEEP_ALIVE',item.name)
          this.tagList.splice(i, 1)
          bool ? this.$router.push(this.tagList[i - 1].path) : ''
          return false
        }
      }
    },
    // 关闭其他
    closeOther() {
      for (let i = 0; i < this.tagList.length; i++) {
        if (i != 0 && this.$route.fullPath != this.tagList[i].path) {
          this.tagList.splice(i, 1)
          i--
        }
      }
      this.menu = false
    },
    // 关闭所有
    closeAll() {
      this.tagList.splice(1, this.tagList.length)
      this.$router.push(this.tagList[0].path)
      this.menu = false
    },
  },
    watch:{
    $route(to){
      to.query.id?this.pitchOn=`${to.name}-${to.query.id}`:this.pitchOn=to.name
    }
  }
}
</script>

<style lang="scss" scoped>
.taglist {
  width: 100%;
  height: 30px;
  line-height: 28px;
  background-color: #ffffff;
  &:hover /deep/.el-scrollbar__wrap {
    overflow-x: scroll;
  }
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
  overflow-y: hidden;
}
.tagmenu {
  background-color: #f4f4f4;
  position: absolute;
  z-index: 99;
  border-radius: 5px;
  padding: 5px 0;
  color: #333333;
  li {
    font-size: 14px;
    line-height: 28px;
    padding: 0 10px;
    cursor: pointer;
  }
  li:hover {
    background-color: #314077;
    color: #ffffff;
  }
}
</style>